<template>
  <div>
    <b-form class="form-horizontal">
      <b-form-group label="Student" label-class="control-label" :class="{ 'invalid-group': $v.studentAsuriteId.$error }">
        <autocomplete ref="studentAutocomplete"
                      :source="studentsApi"
                      placeholder="Search Students"
                      :inputClass="{'form-control' : true, 'is-invalid': $v.studentAsuriteId.$error }"
                      resultsValue="asuriteId"
                      :resultsDisplay="studentDisplay"
                      credentials="include"
                      :request-headers="requestHeaders"
                      v-model="studentAsuriteId"></autocomplete>
      </b-form-group>

      <b-form-group label="Opportunity" label-class="control-label" :class="{ 'invalid-group': $v.opportunityId.$error }">
        <b-form-select v-model="opportunityId" v-if="opportunities" :class="{ 'is-invalid': $v.opportunityId.$error }">
          <option v-for="opportunity in opportunities"
                  :key="opportunity.opportunityId"
                  :value="opportunity.opportunityId">
            {{opportunity.opportunityCategory.name}} @ {{ opportunity.site.name }} ({{ opportunity.term.description }})
          </option>
        </b-form-select>
      </b-form-group>

      <!-- <b-form-group label="Student Type" label-class="control-label" :class="{ 'invalid-group': $v.studentOpportunityTypeId.$error }">
        <b-form-select v-model="studentOpportunityTypeId"
                        :options="studentOpportunityTypes"
                        value-field="studentOpportunityTypeId"
                        text-field="name"
                        :class="{ 'is-invalid': $v.studentOpportunityTypeId.$error }"></b-form-select>
      </b-form-group> -->
    </b-form>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import toastr from "toastr";
import ToastrSettings from "../../settings/toastr-settings";

export default {
  data() {
    return {
      requestHeaders: { "X-Requested-With": "XMLHttpRequest" }
    };
  },

  props: {
    translationalTeamId: {
      required: true
    }
  },

  validations: {
    studentAsuriteId: {
      required
    },
    opportunityId: {
      required
    }
    // studentOpportunityTypeId: {
    //   required
    // }
  },

  computed: {
    studentsApi: function() {
      return process.env.VUE_APP_BASE_URI + "/api/Students/FindStudent?query=";
    },

    translationalTeam: function() {
      return this.$store.state.translationalTeam.translationalTeam;
    },

    opportunities: function() {
      return this.$store.state.translationalTeam.translationalTeam
        .opportunities;
    },

    studentOpportunityTypes: function() {
      return this.$store.state.translationalTeam.studentOpportunityTypes;
    },

    opportunityId: {
      get() {
        return this.$store.state.translationalTeam.newStudentOpportunity
          .opportunityId;
      },
      set(value) {
        this.$store.commit("translationalTeam/updateOpportunityId", value);
      }
    },

    studentAsuriteId: {
      get() {
        return this.$store.state.translationalTeam.newStudentOpportunity
          .asuriteId;
      },
      set(value) {
        this.$store.commit("translationalTeam/updateStudentAsuriteId", value);
      }
    },

    primarySelection: {
      get() {
        return this.$store.state.translationalTeam.newStudentOpportunity
          .primarySelection;
      },
      set(value) {
        this.$store.commit("translationalTeam/updatePrimarySelection", value);
      }
    },

    studentOpportunityTypeId: {
      get() {
        return this.$store.state.translationalTeam.newStudentOpportunity
          .studentOpportunityTypeId;
      },
      set(value) {
        this.$store.commit(
          "translationalTeam/updateStudentOpportunityTypeId",
          value
        );
      }
    }
  },

  methods: {
    // formatted display for student selection
    studentDisplay: function(student) {
      return (
        student.asuriteId + " - " + student.firstName + " " + student.lastName
      );
    },

    save: function() {
      var that = this;
      this.$v.$touch();

      // only submit if the form is valid
      if (!this.$v.$error) {
        this.primarySelection = true;
        this.$store
          .dispatch("translationalTeam/addStudentOpportunity")
          .then(function() {
            that.$store.dispatch("translationalTeam/resetStudentOpportunity");
            that.$store.dispatch(
              "translationalTeam/getTranslationalTeam",
              that.translationalTeamId
            );
            // Toastr Message
            toastr.options = ToastrSettings;
            toastr.success("Student opportunity has been saved.", "Success");
            that.$emit("saved");

            // reset validation
            that.$v.$reset();

            // clear student api selection
            that.$refs.studentAutocomplete.display = null;
          })
          .catch(function(error) {
            console.log(error);
          });
      }
    }
  },

  created() {
    this.$store.dispatch("translationalTeam/getStudentOpportunityTypes");
  }
};
</script>

<style scoped>
</style>
